import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import TabSelector from '../../../Components/TabSelector';
import EpisodeList from './Episode/EpisodeList';
import StudentList from './Student/StudentList';
import EpisodeStats from './EpisodeStats/EpisodeStats';
import StudentProfile from './Student/StudentProfile';

const tabList = [
    'EPISODES',
    'DASHBOARD',
    'STUDENT LIST',
];

class SmartClinic extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            selectedTab: 0,
            studentId: null,
            studentProfileActive: false,
            organizationId: this.props.organizationId,

            defaultLimit: 5,
            defaultOffset: 0,
            defaultSortField: 'modified_time',
            defaultSortBy: 'desc',

            episodesList: [],
            episodesTotal: 0,
            episodesHeader: {},

            studentList: [],
            studentTotal: 0,
            studentHeader: {}
        }
    }

    componentWillMount() {
        let {episodeHeader, studentHeader} = this.props
        let {organizationId} = this.state

        this.props.fetchEpisodeSearch(this.buildHeader({inOrganizationId: organizationId}, episodeHeader))
        this.props.fetchNurseMeta()
        //this.props.fetchStudentSearch(this.buildHeader({inOrganizationId: organizationId}, studentHeader))
        //this.props.fetchEpisodeStats(organizationId)
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    buildHeader = (newHeader, oldHeader) => (Object.assign({}, oldHeader, newHeader))

    _renderNoDataAvail = (msg) => {
        return (
            <div className="hsg-msp-detail-empty">
                    { msg ? msg : "No Data Available"}
            </div>
        )
    }

    openStudentProfile = (studentId) => {

        // studentId 
        // ? this.props.resetEpisodeSearch(this.buildHeader(
        //     {
        //         "inLimit": this.state.defaultLimit,
        //         "inOffset": this.state.defaultOffset,
        //         "inSortField": this.state.defaultSortField,
        //         "inSortBy": this.state.defaultSortBy,
        //         "inStudentId": null,
        //         "inOrganizationId": null,
        //     }, 
        //     this.props.episodeHeader
        // )) 
        // : this.props.fetchEpisodeSearch(this.buildHeader(
        //     {
        //         "inLimit": this.state.defaultLimit,
        //         "inOffset": this.state.defaultOffset,
        //         "inSortField": this.state.defaultSortField,
        //         "inSortBy": this.state.defaultSortBy,
        //         "inStudentId": null,
        //         "inOrganizationId": this.state.organizationId,
        //     }, 
        //     this.props.episodeHeader
        // )) 

        this.setState({
            studentProfileActive: studentId ? true : false,
            studentId: studentId
        })
    }

    _renderCurrentScreen = (state, props) => (
        
        state.studentProfileActive 
        ? 
        this._renderStudentProfile(state, props) 
        :
        state.selectedTab === 0 
        ? 
            <EpisodeList
                episodeList = {props.episodeList}
                episodeTotal = {props.episodeTotal}
                episodeHeader = {props.episodeHeader}
                buildEpisodeHeader = {(newHeader, oldHeader) => this.buildHeader(newHeader, oldHeader)}
                fetchEpisodeSearch = {(header) => this.props.fetchEpisodeSearch(header)}
                openStudentProfile = {(studentId) => this.openStudentProfile(studentId)}
                noDataAvailable = {(msg) => this._renderNoDataAvail(msg)}

                organizationId = {props.organizationId}

                basicInfo = {true}
                parentInfo = {true}
                episodeInfo = {true}
                                
                headingLeft = {'Name'}
                headingRight = {'ModifiedTime'}

                enableEpisodeIdInBody = {true}
                enableEpisodeIdLabelBody = {true}

                baseClass = {'container'}

                enableSearch = {true}
                enableSort = {true}

            />
        : 
        state.selectedTab === 1
        ?
            <EpisodeStats
                stats = {props.episodeStats}
                organizationId = {this.props.organizationId}

                fetchEpisodeStats = {(organizationId) => this.props.fetchEpisodeStats(organizationId)}
                noDataAvailable = {(msg) => this._renderNoDataAvail(msg)}
            />
        :
        state.selectedTab === 2
        ?
            <StudentList
                studentList = {props.studentList}
                studentTotal = {props.studentTotal}
                studentHeader = {props.studentHeader}
                organizationId = {this.props.organizationId}

                buildStudentHeader = {(newHeader, oldHeader) => this.buildHeader(newHeader, oldHeader)}
                fetchStudentSearch = {(header) => this.props.fetchStudentSearch(header)}
                openStudentProfile = {(studentId) => this.openStudentProfile(studentId)}
                noDataAvailable = {(msg) => this._renderNoDataAvail(msg)}
            />
        : 
            null
    )

    onTabSelected(pos) {
        this.setState({
            selectedTab: pos, 
            studentId: null,
            studentProfileActive: false
        });
    }

    _renderClinicTabs = (state, props) => (
        <div>
            <section className="hsg-medh-root">
                <TabSelector
                    tabList={tabList}
                    selected={state.selectedTab}
                    onTabSelected={(pos) => this.onTabSelected(pos)} />
            </section>
            
            {this._renderCurrentScreen(state, props)}
        </div>
    )

    getStudentProfile = (episodeList, studentList, studentId) => {

        let currentStudent
        currentStudent = episodeList.filter((student, index) => (
            student.student_id === studentId 
        ))

        currentStudent = currentStudent && currentStudent.length ? currentStudent[0] : null
        
        if (currentStudent) {
            return currentStudent
        }

        currentStudent = studentList.filter((student, index) => (
            student.student_id === studentId 
        ))

        currentStudent = currentStudent && currentStudent.length ? currentStudent[0] : null
        
        if (currentStudent) {
            return currentStudent
        }else {
            []
        }
    }

    _renderStudentProfile = (state, props) => (
        <section className="hsg-medh-root">
            <StudentProfile
                episodeList = {props.episodeList}
                episodeTotal = {props.episodeTotal}
                episodeHeader = {props.episodeHeader}
                studentId = {state.studentId}
                organizationId = {state.organizationId}

                basicInfo = {false}
                parentInfo = {false}
                episodeInfo = {true}
                                
                headingLeft = {'ModifiedTime'}
                headingRight = {'EpisodeId'}

                enableEpisodeIdInBody = {false}
                enableEpisodeIdLabelBody = {false}
                
                buildHeader = {(newHeader, oldHeader) => this.buildHeader(newHeader, oldHeader)}
                fetchEpisodeSearch = {(header) => this.props.fetchEpisodeSearch(header)}
                closeStudentProfile = {() => this.openStudentProfile(null)}
                studentProfile = {this.getStudentProfile(props.episodeList || [], props.studentList || [], state.studentId)}
                noDataAvailable = {(msg) => this._renderNoDataAvail(msg)}

                postStudentEpisode = {(studentId, customJson, episodeType) => this.props.postStudentEpisode(studentId, customJson, episodeType)}
                initializeForm = {(data) => this.props.initializeForm(data)}
                fetchNurseMeta = {() => this.props.fetchNurseMeta()}

                metaData = { {metaMeds: props.metaMeds, metaSymp: props.metaSymp, metaTreat: props.metaTreat, metaVitals: props.metaVitals} }
                clearForm = {() => this.props.clearForm}
            />
        </section>
    )

    render(){

        let {state, props} = this

        return (
            this._renderClinicTabs(state, props)
        )
    }
}

export default SmartClinic


// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainer/Component/SmartClinic.js